import React from 'react';
import './title.module.css'

export default function Title({ title, fontSize, margin, color = 'black' }) {
  return <h1 style={{ fontSize, margin, color }}>{title}</h1>;
}